import { useContext } from "react"
import { UserContext } from "../../../context/userContext"

//primeReact
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"

//styles
import docSignStyles from "../../../styles/documentSigning/DocSign.templates.module.css"
import { Tooltip } from "primereact/tooltip"
import { useState } from "react"

export default function TemplateViewTable({
  templates,
  deletingTemplateIds,
  stripMetaKey,
  appliedSorting,
  onEditTemplate,
  onEditOrganizations,
  onShowTemplate,
  onDeleteTemplate,
  onSortTemplates,
  organizations,
}) {
  const [sortField, setSortField] = useState(appliedSorting.sortField)
  const [sortOrder, setSortOrder] = useState(appliedSorting.sortOrder)

  const userCtx = useContext(UserContext)

  function CreatedEntryBody(rowData) {
    return (
      <div
        style={{
          marginLeft: 10,
          marginRight: 5,
        }}
      >
        {rowData?.templateCreatedOn.toLocaleString()}
      </div>
    )
  }

  function getOrganizationName(organization_id) {
    let organizationName = `<Unknown: ${organization_id}>`

    if (!!organizations) {
      let organization = organizations.filter(
        (org) => org.organization_id === organization_id
      )
      if (organization.length > 0) {
        organizationName = organization[0].organization_name
      }
    }

    return organizationName
  }

  function SourceBody(rowData) {
    const templateGroupId = stripMetaKey(rowData.metadata["GroupId"])
    return getOrganizationName(templateGroupId)
  }

  function OrganizationsBody(rowData) {
    if (rowData?.additionalOrganizations?.length > 0) {
      return rowData.additionalOrganizations.map((org, index) => {
        return (
          <>
            {getOrganizationName(org)}
            {index < rowData.additionalOrganizations.length - 1 ? <br /> : null}
          </>
        )
      })
    } else {
      return ""
    }
  }

  function ActionsBody(rowData) {
    const templateGroupId = stripMetaKey(rowData.metadata["GroupId"])

    return (
      <div>
        <Tooltip target=".t-tip" />
        {userCtx.session.user.organization_id ===
        userCtx.session.user.enterprise_id ? (
          <button
            type="button"
            className={`btn t-tip ${docSignStyles.cardOptionButton}`}
            data-pr-tooltip={"Manage organization allocation"}
            data-pr-position="bottom"
            onClick={(e) => {
              onEditOrganizations(rowData)
            }}
            disabled={templateGroupId !== userCtx.session.user.organization_id}
          >
            <span className={`material-icons`}>{"groups"}</span>
          </button>
        ) : null}
        <button
          type="button"
          className={`btn t-tip ${docSignStyles.cardOptionButton}`}
          data-pr-tooltip={"Edit template"}
          data-pr-position="bottom"
          onClick={(e) => {
            onEditTemplate(rowData.templateId)
          }}
          disabled={templateGroupId !== userCtx.session.user.organization_id || deletingTemplateIds.includes(rowData.templateId)}
        >
          <span className={`material-icons`}>{"edit"}</span>
        </button>
        <button
          type="button"
          className={`btn t-tip ${docSignStyles.cardOptionButton}`}
          style={{ padding: "5px 8px" }}
          data-pr-tooltip={"Additional template information"}
          data-pr-position="bottom"
          onClick={(e) => {
            onShowTemplate(rowData)
          }}
        >
          <span className={`material-icons`}>{"info"}</span>
        </button>
        <button
          type="button"
          className={`btn t-tip ${docSignStyles.cardOptionButton}`}
          data-pr-tooltip={"Remove template"}
          data-pr-position="bottom"
          onClick={(e) => {
            onDeleteTemplate(rowData)
          }}
          disabled={templateGroupId !== userCtx.session.user.organization_id || deletingTemplateIds.includes(rowData.templateId)}
        >
          <span className={`material-icons`}>{"delete"}</span>
        </button>
      </div>
    )
  }

  return (
    <DataTable
      value={templates?.items}
      sortField={appliedSorting.sortField}
      sortOrder={appliedSorting.sortOrder}
      onSort={(event) => {
        setSortField(event.sortField)
        setSortOrder(event.sortOrder)
        onSortTemplates(event.sortField, event.sortOrder)
      }}
    >
      <Column field="title" header="Title" sortable />
      <Column field="templateCreatedBy" header="Creator" sortable />
      <Column
        header="Creation date"
        field="templateCreatedOn"
        body={CreatedEntryBody}
        sortable
      />
      {userCtx.session.user.organization_id ===
      userCtx.session.user.enterprise_id ? (
        <Column header="Organizations" body={OrganizationsBody} />
      ) : null}
      <Column header="Owner" body={SourceBody} />
      <Column header="Actions" body={ActionsBody} style={{ width: "232px" }} />
    </DataTable>
  )
}
